import React from 'react';
import {Button, Modal, Table, Timeline} from "antd";
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {message} from "../../../utils/message";
import {formatTime, formatToDay, uuid} from "../../../utils";
import Activiti from "../../activiti/Activity";
import Scrollbars from "react-custom-scrollbars";
import noImg from "../images/noImg.png";
import AuditRemarksModal from './info/auditRemarks/AuditRemarksModal';

class AuditRecord extends BaseComponent {
    static defaultProps = {
        btnName: "审核记录",
        btnType: "primary",
        id: ""
    };
    static propTypes = {
        id: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            auditRecordData: [],//审核记录数据
            record: false,//审核记录弹窗
            flowVisible: false, //流程记录
            updateVisible: false, //修改记录
            updateRecordData: [], //修改记录数据
            flowRecordData: [], //流程记录数据
            currentData: {}
        }
    }

    componentDidMount() {

    }

    auditRecordData() {
        const {id} = this.props;
        this.request({
            url: "/cm-sites-sys/process/getProcessHistory",
            body: {bizKey: id},
            callBack: (data) => {
                let auditRecordData = [];
                if (data && data.length > 0) {
                    data.reverse();
                    let _arr = JSON.parse(JSON.stringify(data));
                    let newArr = [];
                    if (_arr.some(item => item.done)) {
                        while (_arr.findIndex(item => item.done) >= 0) {
                            let index = _arr.findIndex(item => item.done)
                            let arr = _arr.splice(0, index + 1)
                            newArr.push(arr);
                        }
                        if (_arr && _arr.length) {
                            newArr.push(_arr);
                        }
                    } else {
                        newArr.push(_arr)
                    }
                    newArr.forEach((item1, index1) => {
                        let operation = [];
                        //第一项记录是它本身
                        if (index1 === 0) {
                            operation = JSON.parse(JSON.stringify(item1));
                        }
                        if (index1 > 0) {
                            if (newArr[index1 - 1].length > 0) {
                                //取前一条记录的最后一项
                                operation.push(newArr[index1 - 1][newArr[index1 - 1].length - 1])
                            }
                            //把前一条的最后一项和当前的合并
                            operation = [...operation, ...JSON.parse(JSON.stringify(item1))];
                        }
                        auditRecordData.push({
                            key: index1,
                            history: JSON.parse(JSON.stringify(item1)),
                            operation: operation
                        })
                    })
                }
                auditRecordData.reverse();
                this.setState({auditRecordData, record: true})
            },
            errorCallBack: () => {
                message.warn("暂无审核记录！");
            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    auditRemarksLoadKey = uuid();

    getColumns() {
        const {activityTypeData, positionRecordOnlineOpen} = this.props;
        return ([
            {
                title: '审核类型',
                key: 'auditType',
                ellipsis: true,
                width: 130,
                render: (text, record) => {
                    let processType = record.history[0]?.processData?.data?.processType;
                    let currentItem = activityTypeData.length && activityTypeData.find(item => item.type === processType);
                    return (
                        <div title={currentItem.name} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{currentItem.name} </div>
                    )
                }
            },
            {
                title: '申请人',
                key: 'assigneeName',
                ellipsis: true,
                render: (text, record) => {
                    let belongUserName = "";
                    if (record?.history?.[0]?.processData) {
                        let data = record.history[0].processData?.data;
                        belongUserName = data?.belongUserName || data?.createByName;
                    }
                    return (
                        <div title={belongUserName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{belongUserName} </div>
                    )
                }
            },
            {
                title: '申请时间',
                key: 'startTime',
                ellipsis: true,
                width: 150,
                render: (text, record) => {
                    return (
                        <div title={record.history[0].createTime ? formatTime(record.history[0].createTime) : null}
                             style={{
                                 overflow: "hidden",
                                 textOverflow: "ellipsis",
                                 whiteSpace: "nowrap"
                             }}>{record.history[0].createTime ? formatTime(record.history[0].createTime) : null} </div>
                    )
                }
            },
            {
                title: '结束时间',
                key: 'endTime',
                ellipsis: true,
                width: 150,
                render: (text, record) => {
                    return (
                        <div
                            title={record.history[record.history.length - 1].updateTime ? formatTime(record.history[record.history.length - 1].updateTime) : null}
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{record.history[record.history.length - 1].updateTime ? formatTime(record.history[record.history.length - 1].updateTime) : null} </div>
                    )
                }
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                ellipsis: true,
                render: (text, record) => {
                    let statusName = record.history[record.history.length - 1]?.taskName;
                    let processData = record.history[0];
                    if (record?.history?.[0]?.processData) {
                        let data = record.history[0].processData?.data;
                        if (data?.belongUserAccount && data?.processType === 5) {
                            if (processData?.operatorUser === data?.belongUserAccount) {
                                statusName = "已领取";
                            } else {
                                statusName = "已分派";
                            }
                        }
                    }
                    return (
                        <div title={statusName} style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{statusName} </div>
                    )
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 300,
                render: (text, record, index) => {
                    let processType = record.history[0]?.processData?.data?.processType;
                    let isShowUpdateRecordBtn = processType === 1 || processType === 4;
                    let data = record.history?.[record.history.length - 1]?.processData?.data;
                    let showExt = data?.activityExt && Object.keys(data.activityExt).length > 0;
                    return (
                        <div>
                            <a style={{display: 'inline-block'}} onClick={() => {
                                this.setState({flowVisible: true, currentData: record.history})
                            }}>流程记录</a>
                            {isShowUpdateRecordBtn ?
                                <a style={{display: 'inline-block', marginLeft: '10px'}} onClick={() => {
                                    this.updateRecord(record)
                                }}>修改记录</a> : null}
                            {showExt && <a style={{display: "inline-block", marginLeft: "10px"}} onClick={() => {
                                this.setState({currentInfo: record})
                                this.auditRemarks.openSetFormData(record.history?.[record.history.length - 1], () => {
                                    message.warn("当前无附加信息字段");
                                }, record.history?.[record.history.length - 1]?.processData?.data?.activityExt);
                            }}>附加信息</a>}
                            {positionRecordOnlineOpen &&
                                <a style={{display: 'inline-block', marginLeft: '10px'}} onClick={() => {
                                    this.downRecordForm(record)
                                }}>下载备案表</a>}
                        </div>
                    )
                }
            }
        ])
    }

    downRecordForm = (record) => {
        let positionItem = record.history?.[0]?.processData?.data;
        let historyItem = record.history?.[record.history.length - 1];
        let body = {
            positionId: positionItem?.id,
            processId: historyItem?.id
        };
        this.checkRecordForm(positionItem?.id, () => {
            this.request({
                url: "/cm-sites-media-consumer/position/handler/outPutToPdf",
                body: body,
                method: "downloadGet",
                callBack: (data) => {
                },
                errorCallBack: () => {
                },
                serverVerify: {
                    serverErrorCallBack: () => {
                    }
                }
            })
        })
    }

    checkRecordForm = (id, callback) => {
        this.request({
            url: "/cm-sites-media-consumer/position/handler/checkRecordFormTemplate",
            body: {positionId: id},
            method: "get",
            callBack: (data, status) => {
                if (status === 200) {
                    callback()
                }
            },
            errorCallBack: () => {
            },
            serverVerify: {
                serverErrorCallBack: () => {
                },
                isShowErrorMsg: true
            }
        })
    }

    render() {
        const columns = this.getColumns();
        return (
            <>
                <Button type={this.props.btnType} style={{...(this.props.btnStyle || {})}} onClick={() => {
                    this.showModal()
                }}
                >
                    {this.props.btnName}
                </Button>
                <Modal
                    title="审核记录"
                    visible={this.state.record}
                    onCancel={() => {
                        this.setState({record: false})
                    }}
                    width={1050}
                    bordered
                    maskClosable={false}
                    zIndex={1000}
                    footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({record: false})
                        }}>关闭</Button>
                    </div>}
                >
                    <div id={"auditRecordTable"}>
                        <Scrollbars autoHide autoHeight autoHeightMax={500}>
                            <Table rowKey={record => record.key} dataSource={this.state.auditRecordData}
                                   columns={columns} pagination={false}/>
                        </Scrollbars>
                    </div>
                </Modal>
                <style>{
                    `#auditRecordTable .ant-table-body{border: 1px solid #e8e8e8;}
                `}</style>
                <Modal
                    title={"流程记录"}
                    zIndex={3000}
                    maskClosable={false}
                    visible={this.state.flowVisible}
                    onCancel={() => {
                        this.setState({flowVisible: false})
                    }}
                    footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({flowVisible: false})
                        }}>关闭</Button>
                    </div>}
                >
                    <div>
                        <Scrollbars
                            autoHide
                            autoHeight
                            autoHeightMax={600}
                        >
                            <div style={{
                                position: "relative",
                                paddingLeft: this.state.currentData && this.state.currentData.length ? 130 : ""
                            }}>
                                <Timeline
                                    style={{marginTop: '2px'}}>{this.state.currentData && this.state.currentData.length ? this.state.currentData.map((item, index) => {
                                    let candidateNames = "";
                                    let operatorName = "";
                                    let endTime = "";
                                    let remark = item.otherData && item.otherData.remarks;
                                    operatorName = "操作人：" + item.operatorName;
                                    candidateNames = item.candidateNames.length ? ("接收人：" + (item.candidateNames.join("，"))) : "";
                                    endTime = Activiti.util.timeFormat(item.updateTime);
                                    return <Timeline.Item color="green" key={uuid()}>
                                        <div>操作时间：{Activiti.util.timeFormat(item.createTime)}</div>
                                        <div>{operatorName}</div>
                                        {index === this.state.currentData?.length - 1 ?
                                            <div>{candidateNames}</div> : null}
                                        {remark ? <div>审核意见：{remark}</div> : null}
                                        <div style={{position: "absolute", top: 0, left: -145}}>
                                            <span style={{
                                                display: "inline-block",
                                                textAlign: "right",
                                                width: "120px",
                                                fontWeight: "bold"
                                            }}>{item.taskName}</span>
                                        </div>
                                    </Timeline.Item>
                                }) : <Timeline.Item>无流程记录</Timeline.Item>}</Timeline>
                            </div>
                        </Scrollbars>
                    </div>
                </Modal>
                <Modal
                    title="修改记录"
                    zIndex={3000}
                    maskClosable={false}
                    visible={this.state.updateVisible}
                    onCancel={() => {
                        this.setState({updateVisible: false})
                    }}
                    width={600}
                    bordered
                    footer={<div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Button onClick={() => {
                            this.setState({updateVisible: false})
                        }} type={"primary"}>关闭</Button>
                    </div>}
                >
                    <div>
                        <Scrollbars
                            autoHide
                            autoHeight
                            autoHeightMax={500}>
                            {
                                this.state.updateRecordData && this.state.updateRecordData.map((item, index) => {
                                    let newText = item.newText;
                                    let oldText = item.oldText;
                                    if (Array.isArray(newText)) {
                                        newText = newText.join(",");
                                    }
                                    if (Array.isArray(oldText)) {
                                        oldText = oldText.join(",");
                                    }
                                    let showText = "";
                                    if (newText === "删除") {
                                        showText = <div style={{display: "flex", justifyContent: "flex-start"}}>
                                            <div style={{fontWeight: "bold",}}>删除：</div>
                                            {oldText}</div>
                                    } else if (oldText === "新增") {
                                        showText = <div style={{display: "flex", justifyContent: "flex-start"}}>
                                            <div style={{fontWeight: "bold",}}>新增：</div>
                                            {newText}</div>
                                    } else {
                                        showText = <div style={{display: "flex", justifyContent: "flex-start"}}>
                                            <div style={{fontWeight: "bold"}}>修改：</div>
                                            <div>
                                                <div style={{display: "flex", justifyContent: "flex-start"}}>
                                                    <div>新值：</div>
                                                    {newText}</div>
                                                <div style={{display: "flex", justifyContent: "flex-start"}}>
                                                    <div>旧值：</div>
                                                    {oldText}</div>
                                            </div>
                                        </div>
                                    }
                                    return (
                                        <div key={index}
                                             style={{fontFamily: "MicrosoftYaHei Regular", fontSize: "14px"}}>
                                            <span style={{
                                                fontWeight: "bold",
                                                marginRight: "10px"
                                            }}>{index + 1}.</span>
                                            <span style={{fontWeight: "bold"}}>“{item.name}”</span>
                                            <span style={{margin: "0px 10px", color: "#aaa"}}>将</span>
                                            <span style={{fontWeight: "bold"}}>”{item.chProp}“</span>
                                            {item.chProp === "危险处置人" ? (
                                                <React.Fragment>
                                                    <span style={{
                                                        margin: "0px 10px",
                                                        color: "#aaa"
                                                    }}>进行了如下操作：</span>
                                                    <pre style={{
                                                        whiteSpace: "pre-wrap",
                                                        backgroundColor: "#f8f8f8",
                                                        padding: "10px"
                                                    }}>
                                                        {showText}
                                                    </pre>
                                                </React.Fragment>
                                            ) : (
                                                <>
                                                    <span style={{margin: "0px 10px", color: "#aaa"}}>修改为</span>
                                                    <span
                                                        style={{fontWeight: "bold"}}>“{(item.chProp === "账号logo") ? (
                                                        <img alt="img" style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            objectFit: "cover",
                                                            verticalAlign: "bottom"
                                                        }} src={newText ? newText : noImg}/>
                                                    ) : newText}”</span>
                                                    <span style={{margin: "0px 10px", color: "#aaa"}}>原值为</span>
                                                    <span
                                                        style={{fontWeight: "bold"}}>”{(item.chProp === "账号logo") && oldText ? (
                                                        <img alt="img" style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            objectFit: "cover",
                                                            verticalAlign: "bottom"
                                                        }} src={oldText ? oldText : noImg}/>
                                                    ) : oldText}“</span>
                                                </>
                                            )}
                                        </div>
                                    )
                                })
                            }
                        </Scrollbars>
                    </div>
                </Modal>
                <AuditRemarksModal
                    title={"附加信息"}
                    activityTypeData={this.props.activityTypeData}
                    id={this.props.id}  //阵地id
                    isAuditing={this.props.isAuditing}
                    isUpdateInfo={false}
                    ref={ref => this.auditRemarks = ref}
                    key={this.auditRemarksLoadKey}
                    onCancel={() => {
                        if (!Object.keys(this.state.currentInfo.history[0]?.processData?.data?.activityExt).length) {
                            this.auditRemarksLoadKey = uuid();
                            this.setState({})
                        }
                    }}
                />
            </>
        )
    }

    // 对象深度对比
    deepEqual(a, b) {
        if (a === b) return true;
        if (a instanceof Date && b instanceof Date)
            return a.getTime() === b.getTime();
        if (!a || !b || (typeof a !== "object" && typeof b !== "object")) return a === b;
        if (a.prototype !== b.prototype) return false;
        let keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length)
            return false;
        return keys.every(k =>
            this.deepEqual(a[k], b[k])
        );
    }  
    //修改记录
    updateRecord(record) {
        //重组对比数据
        let needShowList = [];
        let list = JSON.parse(JSON.stringify(record.operation));
        const areArraysEqual = (array1, array2, key) => {
            if (!Array.isArray(array1)) {
                return false;
            }
            const {variableFieldsSetting} = this.props;
            if (array1.length !== array2.length) {
                return false;
            }
            // 判读数组值
            if (array1.length === array2.length) {
                if (array1.some((item, index) => !this.deepEqual(item, array2[index]))) {
                    return false;
                }
            }
            const setting = variableFieldsSetting.find(item => item.labelCode === key);
            if (!setting) {
                return true;
            }
            const componentType = setting.componentType;
            // 附件
            if (componentType === "attachment") {
                return array1.every((item, index) => {
                    // 比较每个附件的 url 是否相同
                    return item && item.url === array2[index].url;
                });
            }
            return true;
        }
        const areObjectsEqual = (obj1, obj2, key) => {
            if (!obj1 || !Object.keys(obj1).length || !obj2 || !Object.keys(obj2).length) {
                return false;
            }
            const {variableFieldsSetting} = this.props;
            if (!Array.isArray(variableFieldsSetting)) {
                return false;
            }
            const fieldCache = new Map();
            for (let i = 0; i < variableFieldsSetting.length; i++) {
                let obj = variableFieldsSetting[i];
                if (!fieldCache.has(obj["labelCode"])) {
                    fieldCache.set(obj["labelCode"], obj);
                }
            }
            const matchedObj = fieldCache.get(key);
            if (!matchedObj) {
                return false;
            }
            let componentType = matchedObj["componentType"];
            // 备案表
            if (componentType === "uploadRecord") {
                return obj1.path === obj2.path;
            }
        };

        const compareDangerDisposeLists = (oldData, newData, needShowList, currentNew) => {
            //危险处置
            const oldDangerDisposeList = oldData?.ext?.dangerDisposeList || [];
            const newDangerDisposeList = newData?.ext?.dangerDisposeList || [];

            // 记录新增、删除和修改的元素
            const addedItems = [];
            const removedItems = [];
            const modifiedItems = [];

            // 遍历两个列表，逐个比较对应位置的数据
            for (let i = 0; i < Math.max(oldDangerDisposeList.length, newDangerDisposeList.length); i++) {
                const oldItem = oldDangerDisposeList[i];
                const newItem = newDangerDisposeList[i];

                if (newItem && !oldItem) {
                    // 新增元素
                    addedItems.push(newItem);
                } else if (!newItem && oldItem) {
                    // 删除元素
                    removedItems.push(oldItem);
                } else if (newItem && oldItem) {
                    // 检查是否有修改
                    const hasChanges = Object.keys(newItem).some(key => {
                        if (key === 'userInfo') {
                            return JSON.stringify(newItem.userInfo) !== JSON.stringify(oldItem.userInfo);
                        }
                        return newItem[key] !== oldItem[key];
                    });

                    if (hasChanges) {
                        modifiedItems.push({ newItem, oldItem });
                    }
                }
            }
            const displayTextFun = (item) => {
                return <div style={{display: "inline-block"}}>
                    危险处置人：{item?.userInfo?.text}<br/>
                    处置人手机号码：{item?.userNumber}<br/>
                    处置人邮箱：{item?.userEmail}
                </div>
            };

            // 生成具体的展示数据
            addedItems.forEach(newItem => {
                const displayText = displayTextFun(newItem);
                let currentItem = {
                    name: currentNew.operatorName,
                    chProp: "危险处置人",
                    newText: displayText,
                    oldText: "新增"
                };
                needShowList.push(currentItem);
            });

            removedItems.forEach(removedItem => {
                const displayText = displayTextFun(removedItem);
                let currentItem = {
                    name: currentNew.operatorName,
                    chProp: "危险处置人",
                    newText: "删除",
                    oldText: displayText
                };
                needShowList.push(currentItem);
            });

            modifiedItems.forEach(modifiedItem => {
                const oldDisplayText = displayTextFun(modifiedItem.oldItem);
                const newDisplayText = displayTextFun(modifiedItem.newItem);
                let currentItem = {
                    name: currentNew.operatorName,
                    chProp: "危险处置人",
                    newText: newDisplayText,
                    oldText: oldDisplayText
                };
                needShowList.push(currentItem);
            });
        }

        const compareObjectProperties = (obj1, obj2) => {
            const keysObj1 = Object.keys(obj1);
            const keysObj2 = Object.keys(obj2);
            // 比较键的数量
            if (keysObj1.length > keysObj2.length) {
                return obj1;
            } else if (keysObj1.length < keysObj2.length) {
                return obj2;
            } else {
                return obj1;
            }
        }

        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (i > 0) {
                    let currentOld = list[i - 1];
                    let currentNew = list[i];
                    if ((currentOld.processData && currentOld.processData.data) &&
                        (currentNew.processData && currentNew.processData.data)
                    ) {
                        let oldData = JSON.parse(JSON.stringify(currentOld.processData.data));
                        let newData = JSON.parse(JSON.stringify(currentNew.processData.data));
                        if (oldData.name !== newData.name) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '账号名称',
                                newText: newData.name,
                                oldText: oldData.name,
                            }
                            needShowList.push(currentItem)
                        }
                        if (oldData.positionTypeId !== newData.positionTypeId) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '媒体平台',
                                newText: newData.positionTypeName,
                                oldText: oldData.positionTypeName,
                            }
                            needShowList.push(currentItem)
                        }
                        if (oldData.logo !== newData.logo) {
                            let currentItem = {
                                name: currentNew.operatorName,
                                chProp: '账号logo',
                                newText: newData.logo,
                                oldText: oldData.logo,
                            }
                            needShowList.push(currentItem)
                        }

                        // 主逻辑部分
                        if (newData.ext && newData?.ext?.dangerDisposeList) {
                            compareDangerDisposeLists(oldData, newData, needShowList, currentNew);
                        }

                        let newObj = compareObjectProperties(oldData.ext, newData.ext);
                        //维护字段
                        for (var key in newObj) {
                            if (key === "dangerDisposeList") {
                                continue;
                            }
                            if (Array.isArray(newData.ext[key]) || Array.isArray(oldData.ext[key])) {
                                if (!areArraysEqual(oldData.ext[key], newData.ext[key], key)) {
                                    let currentItem = {
                                        name: currentNew.operatorName,
                                        chProp: this.getChProp(key),
                                        newText: this.getText(newData, newData.ext[key], key),
                                        oldText: this.getText(oldData, oldData.ext[key], key),
                                    }
                                    needShowList.push(currentItem);
                                }
                            } else if (typeof newData.ext[key] === "object" || typeof oldData.ext[key] === "object") {
                                if (!areObjectsEqual(oldData.ext[key], newData.ext[key], key)) {
                                    let currentItem = {
                                        name: currentNew.operatorName,
                                        chProp: this.getChProp(key),
                                        newText: this.getText(newData, newData.ext[key], key),
                                        oldText: this.getText(oldData, oldData.ext[key], key),
                                    }
                                    needShowList.push(currentItem);
                                }
                            } else if (oldData.ext[key] !== newData.ext[key]) {
                                let currentItem = {
                                    name: currentNew.operatorName,
                                    chProp: this.getChProp(key),
                                    newText: this.getText(newData, newData.ext[key], key),
                                    oldText: this.getText(oldData, oldData.ext[key], key),
                                }
                                needShowList.push(currentItem);
                            }
                        }
                    }
                }
            }
            if (needShowList.length > 0) {
                this.setState({
                    updateRecordData: needShowList,
                    updateVisible: true
                })
            } else {
                message.warn("暂无修改记录");
            }
        }
    }

    getChProp(key) {
        const {variableFieldsSetting} = this.props;
        for (let i = 0; i < variableFieldsSetting.length; i++) {
            let obj = variableFieldsSetting[i];
            if (obj["labelCode"] === key) {
                return obj.labelName;
            }
        }
    }

    getText(data, value, key) {
        const {variableFieldsSetting} = this.props;
        for (let i = 0; i < variableFieldsSetting.length; i++) {
            let obj = variableFieldsSetting[i];
            if (obj["labelCode"] === key) {
                let componentType = obj.componentType;
                if (componentType && (typeof (this["render" + componentType]) == 'function')) {
                    return this["render" + componentType](obj, value, data)
                } else {
                    return value;
                }
            }
        }
    }

    renderselect = (obj, value) => {
        if (Array.isArray(value)) {
            return obj.fieldProps.options.filter(item => value.indexOf(item.key) > -1).map(item => item.label).join("，");
        } else {
            return obj.fieldProps.options.filter(item => item.key === value).map(item => item.label).join("，");
        }
    }

    renderdatePicker = (obj, value) => {
        return value ? formatToDay(value) : "";
    }

    renderuploadRecord = (obj, value) => {
        return (value?.path) ? value.name : "";
    }

    renderattachment = (obj, value) => {
        return (value || []).map(item => item.name).join("，");
    }

    renderunitSelect = (obj, value, item) => {
        return item?.mainDeptName;
    }

    renderconfirmBox = (obj, value) => {
        return value ? "勾选" : "未勾选";
    }

    showModal = () => {
        this.setState({
            record: true,
        });
        this.auditRecordData();
    };

}

export default AuditRecord;
